const TELEGRAM_ENTRY_PATH = '/telegram';
const TELEGRAM_SDK_SCRIPT_ID = 'telegram-mini-app-sdk';
const TELEGRAM_SDK_SOURCE = 'https://telegram.org/js/telegram-web-app.js?64';
const TELEGRAM_SDK_TIMEOUT_MS = 4_000;

export interface TelegramMiniApp {
  expand(): void;
  ready(): void;
}

declare global {
  interface Window {
    Telegram?: {
      WebApp?: TelegramMiniApp;
    };
  }
}

function loadTelegramSdk(): Promise<void> {
  return new Promise((resolve) => {
    const existing = document.getElementById(TELEGRAM_SDK_SCRIPT_ID);
    const script =
      existing instanceof HTMLScriptElement ? existing : document.createElement('script');
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeout);
      resolve();
    };
    const timeout = window.setTimeout(finish, TELEGRAM_SDK_TIMEOUT_MS);

    script.addEventListener('load', finish, { once: true });
    script.addEventListener('error', finish, { once: true });
    if (!existing) {
      script.id = TELEGRAM_SDK_SCRIPT_ID;
      script.src = TELEGRAM_SDK_SOURCE;
      document.head.append(script);
    }
  });
}

export async function prepareTelegramMiniApp(
  pathname = window.location.pathname
): Promise<TelegramMiniApp | null> {
  if (pathname !== TELEGRAM_ENTRY_PATH) return null;
  if (!window.Telegram?.WebApp) await loadTelegramSdk();
  return window.Telegram?.WebApp ?? null;
}

export function activateTelegramMiniApp(webApp: TelegramMiniApp | null): void {
  if (!webApp) return;
  webApp.ready();
  webApp.expand();
}
